import { SelectProps, Input, Form, Select } from "antd";
import React from "react";
import { MyColor } from "../config/myStyle";
import { CheckOutlined } from '@ant-design/icons';

type MyTimeLineProps = {
    current: number;      // 当前高亮的步骤(1~steps.length)
    steps?: number;       // 步数，默认为3
    style?: React.CSSProperties
    className?: string
}
export const MyTimeLine = (props: MyTimeLineProps) => {
    const steps = props.steps || 3
    const current = props.current || 0
    const items = Array.from({ length: steps });
    return (
        <div
            className={props.className}
            style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                ...props.style || {},
            }}>
            {items.map((_, i) => (
                <React.Fragment key={i}>
                    {/* 圆圈步骤号 */}
                    <div
                        style={{
                            width: 33,
                            height: 33,
                            borderRadius: "50%",
                            border: `2.2px solid ${i < current ? MyColor.primary : "#ccc"}`,
                            color: "rgba(0,0,0,0.4)",
                            background: i < current ? MyColor.primary : "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 18,
                            fontWeight: 400,
                            position: "relative",
                            zIndex: 1,
                            transition: "border-color .2s"
                        }}
                    >
                        {i < current ? <CheckOutlined
                            style={{ color: 'white', fontSize: 18, }}
                        /> : i + 1}

                    </div>
                    {/* 横线，最后一个圈右侧无线 */}
                    {i < steps - 1 && (
                        <div style={{
                            flex: 1,
                            height: 2,
                            background:
                                i < current
                                    ? MyColor.primary
                                    : '#ccc',
                            // background:
                            //     i + 1 < current
                            //         ? MyColor.primary
                            //         : i + 1 === current
                            //             ? `linear-gradient(to right,MyColor.primary60%, #ccc 40%)`
                            //             : "#ccc",
                            margin: "0 0",
                            minWidth: 25,
                            maxWidth: 120
                        }} />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
}